export const billingProfileHc = {
  datosFacturacion: {
    titulo: "Billing details",
    requeridos: "Billing details are required",
  },
  perfil: {
    swalTitle: "Check your email",
    swalText:
      "To continue changing your password, check your inbox and follow the steps",
    swalConfirm: "Continue",
    errorInesperado: "Oops! An unexpected error occurred",
  },
  facturacionCuenta: {
    editarInfo: "Edit information",
    direccionLinea1: "Address line 1",
    direccionLinea2: "Address line 2 (optional)",
    cancelar: "Cancel",
    guardando: "Saving...",
    guardarCambios: "Save changes",
    errorCargar: "Error loading billing details",
    actualizadoOk: "Data updated successfully",
    errorActualizar: "Update error",
    errorActualizarDatos: "Error updating the data",
  },
};
